import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_UTILITY_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserData } from "../../../Base/helper/baseFunctions";
import NProgress from "nprogress";

export const GetWorkLocationHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/ancillary/getWorkLocation`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: params?.domain_name || data?.domain,
            country: "india"
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

export const AddWorkLocationHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/ancillary/addWorkLocation`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: data?.domain,
            user_empid: data?.employee_id,
            work_location_name: params?.name || params?.work_location_name,
            country: "india",
            professional_tax_region_id: params?.professional_tax_region_id?.professional_tax_region_id,
            id_default: params?.is_default || false,
            lat_long: params?.lat_long,
            radius: params?.radius,
            location_name: params?.location_name
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Work Location Added Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

export const UpdateWorkLocationHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/ancillary/updateWorkLocation`, {
        method: "PUT",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: data?.domain,
            user_empid: data?.employee_id,
            ats_work_location_id: params?.ats_work_location_id,
            work_location_name: params?.work_location_name,
            country: "india",
            professional_tax_region_id: params?.professional_tax_region_id?.professional_tax_region_id,
            id_default: params?.is_default || false,
            lat_long: params?.lat_long,
            radius: params?.radius,
            location_name: params?.location_name
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Work Location Updated Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

export const DeleteWorkLocationHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Deleting...")
    return await axiosInstance(`/ancillary/deleteWorkLocation`, {
        method: "DELETE",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: data?.domain,
            ats_work_location_id: params?.ats_work_location_id,
            country: "india",
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Work Location Deleted Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

export const GetStateCityPTHelper = async () => {
    NProgress.start();
    return await axiosInstance(`/ancillary/getStateCityPT`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: getDomain(),
            country: "india"
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Failed", hasError: true, data: err?.data }
        })
}